// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tiue","label":"styles_label__2Bwha"};